import { LitElement, html, css } from '@hh/global.js'

class HHCheckboxWrapper extends LitElement {
  static properties = {
    checked: {
      reflect: true,
    },
  }

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()

    this.checked = this.querySelector('input')?.checked
  }

  onChange(e) {
    this.checked = e?.target?.checked
  }

  render() {
    return html`
      <div>
        <slot @change="${this.onChange}" name="input"></slot>
        <slot name="label"></slot>
      </div>
    `
  }

  static styles = css`
    div {
      display: flex;
      gap: 6px;
      padding-top: 5px;
      padding-bottom: 5px;
    }

    div:hover ::slotted(input) {
      background-color: var(--hh-color-aged-black);
      cursor: pointer;
    }

    ::slotted(input) {
      appearance: none;
      background-color: var(--hh-color-ancient-ore, #000);
      height: max(16px, 1.1vw);
      margin: 1px 0 0;
      position: relative;
      width: max(16px, 1.1vw);
      min-width: 16px;
    }

    ::slotted(label) {
      color: var(--hh-color-aged-black);
      cursor: pointer;
      font: var(--hh-body-font);
      position: relative;
      width: fit-content;
    }

    ::slotted(input):before {
      content: '';
      background-color: var(--hh-color-star-white, #faf9f8);
      display: block;
      height: max(14px, 0.97vw);
      inset: max(0.06vw, 1px);
      position: absolute;
      width: max(14px, 0.97vw);
    }

    :host([checked='true']) ::slotted(input):after {
      content: '';
      background-color: var(--hh-color-fermented-honey, #ad7821);
      display: block;
      height: max(10px, 0.7vw);
      inset: max(0.2vw, 3px);
      position: absolute;
      width: max(10px, 0.7vw);
    }
  `
}

customElements.define('hh-checkbox-wrapper', HHCheckboxWrapper)
